<script>
export default {
  props: ['id'],
  emits: ['loadinged', 'close-drawer'],
  data() {
    return {
      circle: '',
      locked: false,
      circle_role: '',
      password: '',
      payIndex: 0,
    };
  },
  mounted() {
    if (!qktoken) return this.$createModal('login');

    if (typeof qk_circle !== 'undefined') {
      this.circle = qk_circle;
      this.getCircleRoleData();
    }
  },
  methods: {
    getCircleRoleData() {
      this.$http.post(`${qk_rest_url}getCircleRoleData`, { circle_id: this.circle.id }).then((res) => {
        this.circle_role = res.data;
        this.$emit('loadinged');
      }).catch((err) => {
        this.$emit('loadinged');
        this.$message({ message: qkGetApiError(err, '加载圈子信息失败'), type: 'error' });
      });
    },
    payJoin() {
      if (!this.circle_role.pay_group[this.payIndex]) return;

      qkpay({
        order_price: this.circle_role.pay_group[this.payIndex].price,
        order_type: 'join_circle',
        post_id: this.circle.id,
        title: '加入圈子',
        type: this.circle_role.type,
        tag: this.circle_role.pay_group[this.payIndex].name,
        order_key: this.payIndex,
        order_value: this.circle_role.pay_group[this.payIndex].time,
      });
    },
    passwordJoin() {
      const data = qk_global.password_verify;
      data.post_id = this.circle.id;
      data.type = 'circle';
      data.confirm = (params) => {
        this.password = params.code;
        this.joinCircle();
      };

      this.$createModal('passwordVerify', {
        size: 312,
        loading: false,
        props: { data },
      });
    },
    joinCircle() {
      if (this.locked) return;
      this.locked = true;

      const params = {
        circle_id: this.circle.id,
        password: this.password,
        type: this.circle_role.type,
      };

      this.$http
        .post(`${qk_rest_url}joinCircle`, params)
        .then(() => {
          this.locked = false;
          this.$emit('close-drawer');
          this.$message({ message: '加入成功', type: 'success' });
          setTimeout(() => {
            qkCurrentPageReload();
          }, 2000);
        })
        .catch((err) => {
          this.locked = false;
          this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
        });
    },
  },
};
</script>

<template>
  <div class="join-circle-container">
    <div class="circle-info">
      <div class="half-circle"></div>
      <div class="circle-image">
        <img :src="circle.icon" width="46" height="46" class="circle-image-face w-h" />
        <div class="role-badge">{{ circle_role.type_name }}</div>
      </div>
      <div class="circle-name">{{ circle.name }}</div>
      <p>
        欢迎您即将成为第 <span>{{ parseInt(circle.user_count, 10) + 1 }}</span> 位成员
      </p>
    </div>
    <div v-if="circle_role.type === 'roles'" class="roles-box">
      <div class="separator-text">专属圈子，以下用户组可加入</div>
      <ul class="roles-list">
        <li v-for="(item, index) in circle_role.roles" :key="index" class="role-item">
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div v-if="circle_role.type === 'credit' || circle_role.type === 'money'" class="pay-group-box">
      <div class="separator-text">付费加入圈子</div>
      <ul class="pay-group-list">
        <li
          v-for="(item, index) in circle_role.pay_group"
          :key="index"
          class="pay-item pay-info"
          :class="{ 'bg-text': payIndex === index }"
          @click="payIndex = index"
        >
          <div class="pay-info-title">{{ item.name }}</div>
          <div class="pay-info-price">
            <span class="left">服务时间：{{ item.time === 0 ? '永久有效' : item.time + '天' }}</span>
            <span class="rigth">
              <div class="pay-price">
                <span class="unit">{{ circle_role.type === 'credit' ? '积分' : '￥' }}</span>
                <span class="num">{{ item.price }}.00</span>
              </div>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <div class="confirm-button join-circle">
      <button v-if="circle_role.type === 'password'" @click="passwordJoin">输入密码加入</button>
      <button v-else-if="circle_role.type === 'free'" @click="joinCircle">免费加入</button>
      <button v-else-if="circle_role.type === 'roles' && circle_role.allow" @click="joinCircle">
        加入圈子
      </button>
      <button
        v-else-if="circle_role.type === 'credit' || circle_role.type === 'money'"
        @click="payJoin"
      >
        支付入圈
      </button>
      <button v-else disabled>无权加入</button>
    </div>
  </div>
</template>
